// Geo helpers for the Hajj rites map (Makkah area) + live "nearest station" logic.
export const HAJJ_LOCS = [
  { id: "makkah", coords: [21.4225, 39.8262], primary: true },
  { id: "mina", coords: [21.4133, 39.8933] },
  { id: "muzdalifah", coords: [21.3894, 39.9436] },
  { id: "arafah", coords: [21.3549, 39.9843] },
  { id: "jamarat", coords: [21.4218, 39.8735] },
];
export const HAJJ_ROUTE = ["makkah", "mina", "arafah", "muzdalifah", "jamarat", "makkah"];
export const KAABA = [21.4225, 39.8262];
export const FAR_KM = 30;

// Last known device position (shared by the dashboard and the global prayer/drink alerts).
const POS_KEY = "last_pos";
export const readLastPos = () => {
  try { const v = JSON.parse(localStorage.getItem(POS_KEY)); return Array.isArray(v) && v.length === 2 ? v : null; } catch { return null; }
};
export const writeLastPos = (pos) => { if (pos) localStorage.setItem(POS_KEY, JSON.stringify(pos)); return pos; };

export const LANG_TAG = {
  id: "id-ID", en: "en-US", ar: "ar-SA", fr: "fr-FR", de: "de-DE", es: "es-ES",
  ru: "ru-RU", zh: "zh-CN", ja: "ja-JP", ko: "ko-KR", hi: "hi-IN",
};

const toRad = (d) => (d * Math.PI) / 180;
const toDeg = (r) => (r * 180) / Math.PI;

export function haversineKm(a, b) {
  const R = 6371;
  const dLat = toRad(b[0] - a[0]);
  const dLng = toRad(b[1] - a[1]);
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}

export function bearingDeg(from, to) {
  const p1 = toRad(from[0]), p2 = toRad(to[0]), dl = toRad(to[1] - from[1]);
  const y = Math.sin(dl) * Math.cos(p2);
  const x = Math.cos(p1) * Math.sin(p2) - Math.sin(p1) * Math.cos(p2) * Math.cos(dl);
  return (toDeg(Math.atan2(y, x)) + 360) % 360;
}

const DIRS = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
export const compass8 = (deg) => DIRS[Math.round(deg / 45) % 8];

export function fmtKm(km, lang) {
  const v = Math.max(km, 0.1);
  const digits = v < 10 ? 1 : 0;
  return v.toLocaleString(LANG_TAG[lang] || "en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function nearestStation(pos) {
  let best = null;
  for (const l of HAJJ_LOCS) {
    const km = haversineKm(pos, l.coords);
    if (!best || km < best.km) best = { id: l.id, km, coords: l.coords, bearing: bearingDeg(pos, l.coords) };
  }
  return best;
}
